import React from 'react';
import { Box, Link, TrashIcon } from '@razorpay/blade/components';

export const FloatingDiscardButton = ({
  handleDiscardModal,
  isDisabled = false,
}: {
  handleDiscardModal: () => void;
  isDisabled?: boolean;
}) => {
  return (
    <Box position="absolute" top="spacing.7" right="spacing.7" zIndex={10}>
      <Link
        size="small"
        icon={TrashIcon}
        iconPosition="left"
        variant="button"
        isDisabled={isDisabled}
        onClick={handleDiscardModal}>
        Discard
      </Link>
    </Box>
  );
};
